/**
 * Calendar YYYY-MM-DD in the user's local timezone (matches `<input type="date">`).
 */
export function formatLocalYmd(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Same convention as `Date.getTimezoneOffset`: minutes **east of UTC** for the viewer (use in API query). */
export function getViewerUtcOffsetMinutes(): number {
  return -new Date().getTimezoneOffset();
}
